export default "__VITE_ASSET__eHp$r1Ik__"